import { render, staticRenderFns } from "./Offerte.vue?vue&type=template&id=565b77a6"
import script from "./Offerte.vue?vue&type=script&lang=js"
export * from "./Offerte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports